import React from 'react';
import svgPaths from './svgPaths';
import PropTypes from 'prop-types';

/**
 * CleaningIcon Component
 *
 * Icon representing cleaning standards
 *
 * @param {boolean} isEnabled - Whether the icon should be in enabled state (colored) or disabled (gray)
 */
const CleaningIcon = ({ isEnabled = false }) => {
  const fillColor = isEnabled ? '#2A4490' : '#D9D9D9';
  const strokeColor = isEnabled ? 'black' : '#B9B9B9';

  return (
    <div className="relative size-full min-w-0 min-h-0" data-name="Cleaning icons">
      <svg
        className="block size-full object-contain"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 152.219 141.644"
      >
          <g id="Cleaning icons">
            <path
              d={svgPaths.p25747780}
              fill={fillColor}
              id="Vector 20"
              stroke={strokeColor}
              strokeWidth="0.5"
            />
            <path
              d={svgPaths.p317d5580}
              fill={fillColor}
              id="Vector 19"
              stroke={strokeColor}
              strokeWidth="0.5"
            />
            <path
              d={svgPaths.p19553980}
              fill={fillColor}
              id="Ellipse 472"
              stroke={strokeColor}
              strokeWidth="0.5"
            />
            <path
              d={svgPaths.p1e509780}
              fill="white"
              id="Ellipse 473"
              stroke={strokeColor}
              strokeWidth="0.5"
            />
            <path
              d={svgPaths.pc1a0c00}
              fill={fillColor}
              id="Vector 18"
              stroke={strokeColor}
              strokeWidth="0.5"
            />
            <g id="Subtract">
              <mask fill="white" id="path-6-inside-1_10_1173">
                <path d={svgPaths.p2198d100} />
              </mask>
              <path
                d={svgPaths.p2198d100}
                fill={
                  isEnabled ? 'url(#paint0_linear_10_1173_active)' : 'url(#paint0_linear_10_1173)'
                }
              />
              <path d={svgPaths.p7a6c00} fill={strokeColor} mask="url(#path-6-inside-1_10_1173)" />
            </g>
          </g>
          <defs>
            <linearGradient
              gradientUnits="userSpaceOnUse"
              id="paint0_linear_10_1173"
              x1="103.023"
              x2="-7.43118"
              y1="64.7592"
              y2="52.8068"
            >
              <stop stopColor="#D9D9D9" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
            <linearGradient
              gradientUnits="userSpaceOnUse"
              id="paint0_linear_10_1173_active"
              x1="103.023"
              x2="-7.43118"
              y1="64.7592"
              y2="52.8068"
            >
              <stop stopColor="#2A4490" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
          </defs>
        </svg>
    </div>
  );
};

CleaningIcon.propTypes = {
  isEnabled: PropTypes.bool,
};

export default CleaningIcon;
